import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import isString from 'lodash/isString';
import PropTypes from 'prop-types';
import ReactResizeObserver from 'choerodon-ui/lib/_util/resizeObserver';
import { TextField } from '../text-field/TextField';
import { ResizeType } from './enum';
import calculateNodeHeight from './calculateNodeHeight';
import autobind from '../_util/autobind';
function getResizeProp(resize) {
    switch (resize) {
        case ResizeType.both:
            return 'both';
        case ResizeType.vertical:
            return 'height';
        case ResizeType.horizontal:
            return 'width';
        default:
            return undefined;
    }
}
let TextArea = class TextArea extends TextField {
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'resize',
            'autoSize',
            'onResize',
        ]);
    }
    getOtherProps() {
        const { resize = ResizeType.none, autoSize } = this.props;
        const otherProps = super.getOtherProps();
        const { style = {} } = otherProps;
        style.resize = resize;
        if (resize !== ResizeType.none) {
            style.transition = 'none';
        }
        if (autoSize) {
            const { minRows, maxRows } = autoSize;
            otherProps.rows = minRows;
            const { element } = this;
            if (element) {
                Object.assign(style, calculateNodeHeight(element, true, minRows, maxRows));
            }
        }
        otherProps.style = style;
        return otherProps;
    }
    handleResize(width, height, target) {
        const { onResize } = this.props;
        if (!this.resized) {
            const { element } = this;
            if (element && element.style.width) {
                this.resized = true;
            }
        }
        if (onResize) {
            onResize(width, height, target);
        }
    }
    renderWrapper() {
        const { resize = ResizeType.none } = this.props;
        const text = this.getTextNode();
        const resizable = resize !== ResizeType.none;
        const wrapperProps = this.getWrapperProps() || {};
        const elementProps = this.getOtherProps() || {};
        const lengthElement = this.renderLengthInfo();
        if (this.resized) {
            const { style: wrapperStyle } = wrapperProps;
            wrapperProps.style = {
                ...wrapperStyle,
                width: 'auto',
            };
        }
        const element = (React.createElement("textarea", Object.assign({}, elementProps, { placeholder: this.hasFloatLabel ? undefined : this.getPlaceholders()[0], readOnly: !this.editable, value: isString(text) ? text : this.processValue(this.getValue()) })));
        return (React.createElement("div", Object.assign({ key: "wrapper" }, wrapperProps),
            this.renderPlaceHolder(),
            React.createElement("label", null,
                resizable ? (React.createElement(ReactResizeObserver, { onResize: this.handleResize, resizeProp: getResizeProp(resize) },
                    element,
                    lengthElement)) : React.createElement(React.Fragment, null,
                    element,
                    lengthElement),
                this.renderFloatLabel())));
    }
    handleEnterDown() {
    }
};
TextArea.displayName = 'TextArea';
TextArea.propTypes = {
    cols: PropTypes.number,
    rows: PropTypes.number,
    resize: PropTypes.oneOf([
        ResizeType.vertical,
        ResizeType.horizontal,
        ResizeType.none,
        ResizeType.both,
    ]),
    autoSize: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    ...TextField.propTypes,
};
TextArea.defaultProps = {
    ...TextField.defaultProps,
    suffixCls: 'textarea',
    rows: 4,
    autoSize: false,
};
// eslint-disable-next-line camelcase
TextArea.__PRO_TEXTAREA = true;
__decorate([
    observable
], TextArea.prototype, "resized", void 0);
__decorate([
    autobind,
    action
], TextArea.prototype, "handleResize", null);
TextArea = __decorate([
    observer
], TextArea);
export default TextArea;
